import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navbar from './components/Navbar';
import UrgencyBar from './components/UrgencyBar';
import Hero from './components/Hero';
import Section from './components/Section';
import ComparisonBlock from './components/ComparisonBlock';
import BenefitsBlock from './components/BenefitsBlock';
import TestimonialsResultsBlock from './components/TestimonialsResultsBlock';
import BonusBlock from './components/BonusBlock';
import AuthorBlock from './components/AuthorBlock';
import VerifiedCredentialsBlock from './components/VerifiedCredentialsBlock';
import FAQ from './components/FAQ';
import PaymentModal from './components/PaymentModal';
import WhatsAppSection from './components/WhatsAppSection';
import ThankYou from './components/ThankYou';
import './App.css';

function HomePage() {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);

  useEffect(() => {
    // Detectar si el usuario vuelve del pago
    const params = new URLSearchParams(window.location.search);
    const status = params.get('status');
    if (status === 'success') {
      alert('¡Pago completado exitosamente! Te contactaremos pronto con los detalles del acceso.');
    }
  }, []);

  const handlePaymentClick = () => {
    setIsPaymentModalOpen(true);
  };

  const handlePaymentSuccess = () => {
    setIsPaymentModalOpen(false);
    // alert('¡Gracias por tu compra! En breve recibirás un email con los detalles de acceso.');
  };

  return (
    <div className="App">
      {/* Navbar */}
      <Navbar onPaymentClick={handlePaymentClick} />

      {/* Urgency Bar */}
      {/* <UrgencyBar totalSpots={100} soldSpots={96} /> */}

      {/* Hero Section */}
      <Hero onPaymentClick={handlePaymentClick} />

      {/* Section 2: Problem Statement */}
      <Section theme="light" id="problem">
        <div className="problem-text">
          <p className="problem-content">
            Durante años te han enseñado trading desde el lugar equivocado:
          </p>

          <ul className="problem-list">
            <li>Dudas en cada entrada</li>
            <li>Probar estrategias sin entender por qué funcionan</li>
            <li>Backtests que no se sostienen en real</li>
            <li>Seguir señales sin criterio</li>
            <li>No saber si el problema es la estrategia o tú</li>
            <li>Años operando sin claridad real</li>
          </ul>

          <p className="problem-closing">
            La industria está llena de <span className="emphasis-text">ruido</span>…<br />
            Y tu mente también.
          </p>
        </div>
      </Section>

      {/* Section 3: Comparison */}
      <Section
        theme="dark"
        title="Aquí comienza la claridad que nunca te dieron"
        id="comparison"
      >
        <ComparisonBlock />
      </Section>

      {/* Section 4: About Author */}
      <Section theme="light" id="about">
        <AuthorBlock />
      </Section>

      {/* Section 5: Verified Credentials */}
      <section id="credentials" className="section section-light" style={{ padding: '80px 0', background: 'white' }}>
        <VerifiedCredentialsBlock />
      </section>

      {/* Section 6: Benefits */}
      <Section
        theme="light"
        title="Lo que vivirás en 7 días"
        subtitle="Sprint intensivo de ejecución real. Sin teoría innecesaria."
        id="benefits"
      >
        <BenefitsBlock />
      </Section>

      <Section
        theme="light"
        title="Resultados reales de estudiantes aplicando el método"
        subtitle={
          'Estos resultados corresponden a estudiantes reales aplicando la metodología.\n' +
          'No representan ganancias garantizadas y dependen de la disciplina, gestión del riesgo y ejecución de cada persona.'
        }
        id="testimonios"
      >
        <TestimonialsResultsBlock />
      </Section>

      {/* Section 6.5: Bonuses */}
      <Section
        theme="light"
        id="bonuses"
      >
        <BonusBlock />
      </Section>

      {/* Section 7: Urgency */}
      <Section
        theme="dark"
        title="Sprint intensivo que se dicta únicamente en enero por agenda limitada"
        id="urgency"
      >
        <div className="urgency-content">
          <div className="urgency-text">
            <div>
              <p>No se repite.</p>
              <p>No hay acceso posterior.</p>
              <p>No hay grabaciones.</p>
              <p><strong>No existe "lo veo después".</strong></p>
            </div>
            <p className="urgency-deadline">
              Los cupos se cierran el <strong>31 de diciembre</strong> o cuando se agoten.
            </p>
          </div>
        </div>
      </Section>

      {/* Section 8: Price */}
      <Section
        theme="light"
        title="El precio no es el problema. La decisión sí."
        id="pricing"
      >
        <div className="pricing-content">
          <div className="price-box">
            <p className="price-label">Acceso especial fin de año</p>
            <h3 className="price-amount">$99 USD</h3>
            <p className="price-subtitle">Sprint profesional – Enero</p>
          </div>

          <p className="price-text">
            Esta suma te la gastas fácilmente en un fin de semana en cosas que no te aportan nada.
            <br />
            <strong>Puede ahorrarte años de errores.</strong>
          </p>

          <motion.button
            className="cta-button primary large"
            onClick={handlePaymentClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            👉 Quiero asegurar mi plaza por 99 USD y ser de los primeros 100
          </motion.button>
        </div>
      </Section>

      {/* Section 9: Guarantee */}
      <Section
        theme="dark"
        title="Garantía ética"
        id="guarantee"
      >
        <div className="guarantee-content">
          <div className="guarantee-text">
            <p>
              <strong>No te voy a prometer rentabilidad.</strong>
              <br />
              Nadie serio lo hace.
            </p>

            <p>
              Pero sí te garantizo algo:
            </p>

            <p className="guarantee-highlight">
              ✅ Vas a ver <strong>simplificado 14 años de trabajo</strong>
            </p>

            <p className="guarantee-highlight">
              ✅ Tendrás claridad para decidir si este camino es para ti.
            </p>

            <p>
              Y si después de este entrenamiento descubres que el trading no es para ti…
              <strong> te habrás ahorrado años y miles de dólares.</strong>
            </p>
          </div>
        </div>
      </Section>

      {/* Section 10: FAQ */}
      <Section
        theme="light"
        title="Preguntas Frecuentes"
        id="faq"
      >
        <FAQ />
      </Section>

      {/* Section 11: Final CTA */}
      <Section
        theme="dark"
        id="final-cta"
      >
        <div className="final-cta-content">
          <p className="final-text">
            Si sientes que este <strong>2026 puede ser diferente</strong>…
          </p>
          <p className="final-emphasis">
            Este es el momento.
          </p>

          <motion.button
            className="cta-button primary large"
            onClick={handlePaymentClick}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            👉 Quiero entrar antes de que se agoten los cupos
          </motion.button>
        </div>
      </Section>

      {/* WhatsApp Section */}
      <Section theme="dark" id="whatsapp-contact">
        <WhatsAppSection />
      </Section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo-section">
            <img src="/logo_negro.png" alt="EMI Logo" className="footer-logo" />
            <p className="footer-brand">Entrenamiento EMI</p>
          </div>
          <p className="footer-copyright">&copy; 2026 Entrenamiento EMI - Alfonso Marín. Todos los derechos reservados.</p>
        </div>
      </footer>

      {/* Payment Modal */}
      <PaymentModal
        isOpen={isPaymentModalOpen}
        onClose={() => setIsPaymentModalOpen(false)}
        onSuccess={handlePaymentSuccess}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/gracias" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
